<template>
    <div class="item_header">
        <div class="item_header--title">
            {{ item.name }}
        </div>
        <div class="item_header--duration" v-if="item.duration !== undefined">
            {{ item.duration }}
        </div>
    </div>
    <div class="item_data">
        <div class="item_data--row" v-if="item.end_date">
            <div class="key">
                <i>
                    <img src="../assets/img/sand_clock.png">
                </i>
                Срок действия
            </div>
            <div class="value">
                {{ serviceEndDate }}
            </div>
        </div>
        <div class="item_data--row">
            <div class="key">
                <i>
                    <img src="../assets/img/run.png">
                </i>
                Посещений осталось
            </div>
            <div class="value">
                {{ serviceVisits }}
            </div>
        </div>
    </div>
    <div class="item_price">
        <div class="item_price--key">
            Итого
        </div>
        <div class="item_price--value">
            <currency-symbol :price="item.amount_full"/>
        </div>
    </div>
    <div
            class="item_status"
            :class="'item_status--'+ serviceStatusClass"
            v-if="serviceStatusClass !== 'hide'"
    >
        {{ serviceStatusMessage }}
    </div>
</template>

<script>
    import moment from "moment";
    import CurrencySymbol from "./CurrencySymbol";

    export default {
        name: "ServiceItem",
        components: {CurrencySymbol},
        props: {
            item: {},
        },
        computed: {
            serviceEndDate() {
                return this.item.end_date !== null ? moment(this.item.end_date, 'YYYY-MM-DD').format('DD.MM.YYYY ') : null;
            },
            serviceVisits() {
                return this.item.count.left + ' из ' + this.item.count.total;
            },
            serviceStatusClass() {
                if (this.item.status === 'unpaid'){
                    return 'danger'
                }
                if (this.item.end_date === null){
                    return 'warning'
                }

                return 'hide'
            },
            serviceStatusMessage(){
                if (this.item.status === 'unpaid'){
                    return 'Не оплачено'
                }
                if (this.item.end_date === null){
                    return 'Активация при посещении'
                }

                return ''
            }
        }
    }
</script>